<template>
  <empty-card
    :mainText="$t('page.dashboard.noPayments')"
    :subText="$t('page.dashboard.initiatePayment')"
    :buttonText="$t('common.action.createPayment')"
    :buttonColor="'primary'"
    buttonIcon="mdi-plus"
    @button-click="createPayment"
  >
    <template #image>
      <v-img src="@/shared/assets/payments.png" max-height="150px" min-height="75px" />
    </template>
  </empty-card>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router";
import EmptyCard from "@/shared/components/Common/EmptyCard.vue";
const router = useRouter();
const createPayment = () => {
  router.push({ name: "createPayment" });
};
</script>
